import moment from 'moment';
import FormMixin from '@/mixins/formvalid';
export default {
  components: {},
  mixins: [FormMixin],
  props: ['dialog', 'form'],
  data () {
    return {
      valid: false,
      menu_time: false,
      menu_date: false,
      dateFormatted: null,
      users: [],
      selectedUser: null,
      time: null,
      date: null,
      items: [],
    }
  },
  methods: {
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    unformatDate (date) {
      if (!date) {
        return null
      }
      const [day, month, year] = date.split('/')
      return `${year}-${month}-${day}`
    },
    save () {
      if (this.$refs.form.validate()) {
        this.$emit('save', this.form);
      } else {
        console.log('error: daily form not valid');
      }
    },
    close () {
      this.$emit('close');
    },
    getUsers () {
      this.$http.post('service/user/findByRoles', {roles:'"super", "admin", "dispatch"'})
      .then((response) => {
        console.log(response)
        this.users = response.data || [];
      })
    },
    init (v) {
      if (v) {
        this.form.time = moment().format('HH:mm');
        this.form.date = moment().format('YYYY-MM-DD');
        this.dateFormatted = this.formatDate(this.form.date);
        this.getUsers();
      }
    }
  },
  watch: {
    dialog (value) {
      this.init(value);
    }
  }
}
